import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type MembersMetric = 'enrolledMembers' | 'uniqueMembers' | 'activeMembers';

/** A campaign with no visit ledger serves `enrolledMembers` alone and hides
 * the other two, hence three metrics on one source. */
const config: CampaignSourceConfig<MembersMetric> = {
    label: 'Campaign members',
    endpoint: 'analytics/campaign-members-member',
    metrics: [
        { id: 'enrolledMembers', label: 'Enrolled members', type: 'scalar' },
        { id: 'uniqueMembers', label: 'Unique members', type: 'scalar' },
        { id: 'activeMembers', label: 'Active members', type: 'scalar' },
    ],
    forms: ['trio', 'number', 'line', 'bars', 'columns', 'multiline'],
    multilineMetrics: [
        { label: 'Fully enrolled', metricId: 'enrolledMembers' },
        { label: 'Made a qualifying purchase', metricId: 'activeMembers' },
    ],
    // The businessUnit breakdown's rows carry the count under the metric's
    // own id (row[metricId], like the `bars` path).
    columnsAxisCells: {
        valueCell: 'enrolledMembers',
        forMetric: 'enrolledMembers',
    },
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
};

export const campaignMembersSource = withCampaignWindows(
    createEnvelopeSource(config),
    config
);
